/**
 * Script-tag (CDN) entry. Exposes `window.Cesto` (the loader class,
 * with `bindInvestButtons` attached) and auto-binds `[data-cesto-invest]`
 * elements once the DOM is ready.
 */
import { bindInvestButtons } from './bind-invest-buttons';
import { Cesto } from './cesto';

type CestoGlobal = typeof Cesto & {
  bindInvestButtons: typeof bindInvestButtons;
};

declare global {
  interface Window {
    Cesto?: CestoGlobal;
  }
}

const globalExport = Cesto as CestoGlobal;
globalExport.bindInvestButtons = bindInvestButtons;
window.Cesto = globalExport;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => bindInvestButtons(), {
    once: true,
  });
} else {
  bindInvestButtons();
}
